import axios from 'axios'
import * as HttpStatus from 'http-status-codes'
import { Identifier } from 'react-admin'

export function partialUpdateCustomLoad(loadId: Identifier, payload: any) {
  const url = `/api/v1/console/custom-loads/${loadId}/`
  return axios.patch(url, payload).then((response) => {
    if (response.status === HttpStatus.OK) {
      return response.data
    }
  })
}
